export default __webpack_public_path__ + "static/media/icon-data-error.87d5e875.svg";